module.exports = __webpack_public_path__ + "img/default.0a14e0db.png";